/**
 * @file 报案中心路由文件
 */

// 待处理报案
const pendingReport = resolve =>
  import(
    /* webpackChunkName: "reporting-center" */ '../views/reporting-center/pending-report/index.vue'
  );

// 报案进度
const claimStatus = resolve =>
  import(
    /* webpackChunkName: "reporting-center" */ '../views/reporting-center/claim-status/index.vue'
  );

// 保障服务
const assuranceService = resolve =>
  import(
    /* webpackChunkName: "reporting-center" */ '../views/reporting-center/assurance-service/index.vue'
  );

// 保障服务 --> 申请流程
const applyFlow = resolve =>
  import(
    /* webpackChunkName: "reporting-center" */ '../views/reporting-center/assurance-service/apply-flow.vue'
  );

// 保障服务 --> 常见问题
const FAQ = resolve =>
  import(
    /* webpackChunkName: "reporting-center" */ '../views/reporting-center/assurance-service/FAQ.vue'
  );

export default [
  {
    name: 'reportingCenterPendingReport',
    path: '/reporting-center/pending-report',
    component: pendingReport,
    meta: { title: '报案中心' },
  },
  {
    name: 'reportingCenterClaimStatus',
    path: '/reporting-center/claim-status',
    component: claimStatus,
    meta: { title: '保障金申请进度' },
  },
  {
    name: 'reportingCenterAssuranceService',
    path: '/reporting-center/assurance-service',
    component: assuranceService,
    meta: { title: '保障服务' },
  },
  {
    name: 'reportingCenterApplyFlow',
    path: '/reporting-center/apply-flow',
    component: applyFlow,
    meta: { title: '申请流程' },
  },
  {
    name: 'reportingCenterFAQ',
    path: '/reporting-center/FAQ',
    component: FAQ,
    meta: { title: '常见问题' },
  },
];
